/**
 * Global tracking: GA4, GTM, Meta Pixel, Microsoft Clarity.
 * Uses react-helmet-async (already in project) for script injection.
 */
import { Helmet } from 'react-helmet-async';

const GA_ID = 'G-KVYFRJL2TX';
const GTM_ID = 'GTM-P32TFFDV';
const META_PIXEL_ID = '649137674198438';
const CLARITY_ID = 'vg5u30gevi';

const TrackingHead = () => (
  <>
  <Helmet>
    {/* Google Analytics (GA4) */}
    <script src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`} async />
    <script type="text/javascript">{`
      window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}
      gtag('js',new Date());gtag('config','${GA_ID}');
    `}</script>

    {/* Google Tag Manager */}
    <script type="text/javascript">{`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');
    `}</script>

    {/* Meta (Facebook) Pixel */}
    <script type="text/javascript">{`
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
      t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
      (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init','${META_PIXEL_ID}');fbq('track','PageView');
    `}</script>

    {/* Microsoft Clarity */}
    <script type="text/javascript">{`
      (function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window,document,"clarity","script","${CLARITY_ID}");
    `}</script>
    {/*Chatbot */}
    {/* <script src="//code.tidio.co/yhxnras9c7plswmibil3qgkt4lkvc5gz.js" async></script> */}
  </Helmet>
  {/* GTM noscript: must be in body, right after opening <body> */}
  <noscript dangerouslySetInnerHTML={{ __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>` }} />
  {/* Meta Pixel noscript: must be in body */}
  <noscript dangerouslySetInnerHTML={{ __html: `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" alt="" />` }} />
  </>
);

export default TrackingHead;
